import { motion } from "framer-motion";

function IntegrationSection() {
  const emailProviders = [
    { name: "Gmail", icon: "M24 5.457v13.909c0 .904-.732 1.636-1.636 1.636h-3.819V11.73L12 16.64l-6.545-4.91v9.273H1.636A1.636 1.636 0 0 1 0 19.366V5.457c0-2.023 2.309-3.178 3.927-1.964L5.455 4.64 12 9.548l6.545-4.91 1.528-1.145C21.69 2.28 24 3.434 24 5.457z" },
    { name: "Outlook", icon: "M7.88 12.04q0 .45-.11.87-.1.41-.33.74-.22.33-.58.52-.37.2-.87.2t-.85-.2q-.35-.21-.57-.55-.22-.33-.33-.75-.1-.42-.1-.86t.1-.87q.1-.43.34-.76.22-.34.59-.54.36-.2.87-.2t.86.2q.35.21.57.55.22.34.31.77.1.43.1.88zM24 12v9.38q0 .46-.33.8-.33.32-.8.32H7.13q-.46 0-.8-.33-.32-.33-.32-.8V18H1q-.41 0-.7-.3-.3-.29-.3-.7V7q0-.41.3-.7Q.58 6 1 6h6.5V2.55q0-.44.3-.75.3-.3.75-.3h12.9q.44 0 .75.3.3.3.3.75V10.85l1.24.72h.01q.1.07.18.18.07.12.07.25zm-6-8.25v3h3v-3zm0 4.5v3h3v-3zm0 4.5v1.83l3.05-1.83zm-5.25-9v3h3.75v-3zm0 4.5v3h3.75v-3zm0 4.5v2.03l2.41 1.5 1.34-.8v-2.73zM9 3.75V6h4.5V3.75zm0 4.5v3h4.5v-3zm0 4.5v3h4.5v-3z" },
    { name: "Yahoo Mail", icon: "M19.828 21.172a1.973 1.973 0 0 1-1.997-1.997 1.973 1.973 0 0 1 1.997-1.997 1.973 1.973 0 0 1 1.997 1.997 1.973 1.973 0 0 1-1.997 1.997zm4.172-7.953v6.953a1 1 0 0 1-1 1h-6.812a3.966 3.966 0 0 0 .781-2.375c0-2.202-1.793-3.995-3.995-3.995s-3.995 1.793-3.995 3.995c0 .856.271 1.648.732 2.297a.996.996 0 0 1-.732.078h-6.774a1 1 0 0 1-1-1v-6.953l11.932-7.647z M 19.828 14.795a3.966 3.966 0 0 0-2.375.781V7.969a1 1 0 0 0-1-1H7.547a1 1 0 0 0-1 1v7.607a3.966 3.966 0 0 0-2.375-.781c-2.202 0-3.995 1.793-3.995 3.995s1.793 3.995 3.995 3.995a3.99 3.99 0 0 0 3.213-1.625h7.66a3.99 3.99 0 0 0 3.213 1.625c2.202 0 3.995-1.793 3.995-3.995s-1.793-3.995-3.995-3.995zm-16.853 6.377a1.973 1.973 0 0 1-1.997-1.997 1.973 1.973 0 0 1 1.997-1.997 1.973 1.973 0 0 1 1.997 1.997 1.973 1.973 0 0 1-1.997 1.997z" },
    { name: "Apple Mail", icon: "M11.666 4.848C11.666 2.732 13.368 1 15.484 1c2.116 0 3.818 1.732 3.818 3.848 0 2.116-1.702 3.848-3.818 3.848-2.116 0-3.818-1.732-3.818-3.848zm4.697 4.307c2.355 0 4.697-1.913 4.697-4.545C21.06 1.969 18.718 0 16.363 0c-2.354 0-4.697 1.969-4.697 4.61 0 2.633 2.343 4.545 4.697 4.545zM19.249 24H4.751V8.535h14.498V24zm0-16.384H4.751V5.838h14.498v1.778zM4.751 4.915V4.26c0-.359.293-.652.652-.652h13.194c.359 0 .652.293.652.652v.655H4.751zm14.498-2.47H4.751V1.097c0-.359.293-.652.652-.652h13.194c.359 0 .652.293.652.652v1.348H19.249z" },
    { name: "ProtonMail", icon: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm-4-9a1 1 0 100-2 1 1 0 000 2zm8 0a1 1 0 100-2 1 1 0 000 2zm-5.5 4.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z" },
  ];

  return (
    <section className="py-20 px-4 bg-white">
      <div className="container mx-auto max-w-4xl text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-3xl font-bold mb-4 text-[#694e42]">Works With Your Favorite Email Provider</h2>
          <p className="text-lg text-[#8a7266] mb-12 max-w-3xl mx-auto">
            MailMaid seamlessly integrates with all major email services. No need to change your email address or provider.
          </p>
        </motion.div>
        
        <div className="grid grid-cols-2 md:grid-cols-5 gap-6 items-center justify-center">
          {emailProviders.map((provider, index) => (
            <motion.div
              key={index}
              className="bg-white p-6 rounded-xl shadow-sm border border-[#e2dad3] flex flex-col items-center hover:shadow-md"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              whileHover={{ y: -5 }}
            >
              <svg className="w-8 h-8 mb-3 text-[#694e42]" viewBox="0 0 24 24" fill="currentColor">
                <path d={provider.icon} />
              </svg>
              <span className="text-sm font-medium text-[#694e42]">{provider.name}</span>
            </motion.div>
          ))}
        </div>
        
        <motion.div
          className="mt-12"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.6 }}
        >
          <p className="text-[#8a7266] mb-6">Don't see your provider? We're constantly adding new integrations.</p>
          
          <button className="text-[#ff8c42] font-medium hover:underline">
            Contact us about your email provider →
          </button>
        </motion.div>
      </div>
    </section>
  );
}

export default IntegrationSection;